export type AssetFetcher = (input: RequestInfo | URL, init?: RequestInit) => Promise<Response>;

export class AssetService {
  private readonly baseUrl: URL;
  private readonly allowedOrigin: string;

  constructor(origin: string, private readonly fetcher: AssetFetcher = fetch) {
    this.baseUrl = new URL(origin);
    this.allowedOrigin = this.baseUrl.origin;
  }

  async arrayBuffer(path: string, signal?: AbortSignal): Promise<ArrayBuffer> {
    const response = await this.request(path, signal);
    return response.arrayBuffer();
  }

  async json<T>(
    path: string,
    validate: (candidate: unknown) => candidate is T,
    signal?: AbortSignal,
  ): Promise<T> {
    const response = await this.request(path, signal);
    const value: unknown = await response.json();
    if (!validate(value)) throw new Error("Asset JSON validation failed");
    return value;
  }

  private async request(path: string, signal?: AbortSignal): Promise<Response> {
    const url = new URL(path, this.baseUrl);
    if (url.origin !== this.allowedOrigin) {
      throw new Error("Cross-origin asset rejected");
    }

    const response = await this.fetcher(url.toString(), signal ? { signal } : undefined);
    if (!response.ok) throw new Error(`Asset request failed: ${response.status}`);
    return response;
  }
}
